export enum CartActions {
  ADD = 'add',
  DELETE = 'delete',
  DELETE_SUCCESS = 'delete-success',
  UPDATE = 'update',
  LIMITED = 'limited',
  SIZE_NOT_SELECTED = 'size-not-selected',
}
